import request from './request';

export function logIn(data) {
  return request('post', `/apiv2/user/login`, data);
}

export function signUp(data) {
  return request('post', `/apiv2/user/store`, data);
}
